<header class="header-wrapper">
  <div class="d-flex align-items-center">
    <div class="d-md-none">
      <app-mobile-menu [data]="data" (toggleMenu)="getData()"></app-mobile-menu>
    </div>
    <a class="header-logo" routerLink="/">
      <i class="icon-logo d-none d-md-block"></i>
      <div class="logo d-md-none"></div>
    </a>
  </div>
  <div class="header-menus">
    <div class="header-portfolio">
      <user-portfolio user-portfolio (showPortfolioChange)="onPortfolioClose($event)" [showPortfolio]="shouldShowPortfolio">
        <exchange-balance dropdown class="section pb-1" (close)="onPortfolioClose($event)"></exchange-balance>
      </user-portfolio>
    </div>
    <a routerLink="/accounts/fiat/deposit" class="btn btn-surface" i18n="@@header.main.btn">Deposit</a>
    <div class="d-none d-md-block header-profile">
      <app-user-menu [data]="data" (toggleMenu)="getData()"></app-user-menu>
    </div>
  </div>
</header>
<div class="pseudo-header"></div>
